import {
	ComboBox, ComboBoxProps, IMenuOption, InputParams, isReddit,
	MenuItemSize,
	MenuSelectType,
	MenuWidth,
} from '@aleph/shared-components';
import RedditEntityImage from 'wb-reddit/app/common/components/entityImage';
import { User } from 'wb-reddit/app/routes/teams/utils';

interface IProps {
	options?: User[]
	disabled?: boolean
	onSelect?: (option: IMenuOption) => void
	value: User
	triggerProps?: InputParams
	inputSuffix?: ComboBoxProps['inputSuffix']
}

function TeamOwnerAutocomplete({
	options,
	disabled,
	onSelect,
	value,
	inputSuffix,
}: IProps) {
	return (
		<ComboBox
			label="Owner"
			value={value.userEmail}
			items={options?.map(option => ({
				...option,
				label: isReddit()
					? `${option.userFullName ?? '-'} (${option?.userEmail ?? '-'})`
					: `${option.userName} ${option.userSurname ?? ''} (${option?.userEmail ?? '-'})`,
				value:  option.userId,
				prefix: (
					<RedditEntityImage entity={option} />
				),
				supportingText: option.userEmail?.split('@')[1],
			})) ?? []}
			// @ts-ignore: TODO: type issue in combobox
			onSelect={onSelect}
			disabled={disabled}
			selectType={MenuSelectType.SINGLE_SELECT}
			openMenuOnClick
			menuWidth={MenuWidth.AUTO}
			autoWidth
			menuMaxWidthOfTrigger
			// @ts-ignore: TODO: type issue in combobox
			menuParams={{
				size: MenuItemSize.LARGE,
			}}
			inputSuffix={inputSuffix}
		/>
	);
}

export default TeamOwnerAutocomplete;
